import { useMemo } from 'react';
import { useAuth } from '../context/AuthContext.jsx';

/**
 * Mirrors the role gates declared on the server so the UI never renders a
 * control the API will answer with a 403.
 *
 * server/src/middleware/auth.js
 *   contentEditor  -> super-admin, admin, editor
 *   adminOnly      -> super-admin, admin
 *   superAdminOnly -> super-admin
 */
export const usePermissions = () => {
  const { user } = useAuth();
  const role = user?.role || '';

  return useMemo(
    () => ({
      role,
      isSuperAdmin: role === 'super-admin',
      isAdmin: ['super-admin', 'admin'].includes(role),
      canEditContent: ['super-admin', 'admin', 'editor'].includes(role),
      canDeleteContent: ['super-admin', 'admin'].includes(role),
      canManageMedia: ['super-admin', 'admin', 'editor'].includes(role),
      canDeleteMedia: ['super-admin', 'admin'].includes(role),
      canManageUsers: role === 'super-admin',
      canViewContacts: ['super-admin', 'admin'].includes(role),
      canViewAnalytics: ['super-admin', 'admin'].includes(role),
    }),
    [role],
  );
};
